import { PolylineEdge, PolylineEdgeModel, h } from '@logicflow/core';

// 实心三角形边
export class TriangleFilledEdgeModel extends PolylineEdgeModel {
  getEdgeStyle() {
    const style = super.getEdgeStyle();
    style.stroke = '#ff4d4f';
    style.strokeWidth = 2;
    return style;
  }

  // 重写getData方法以保存锚点信息
  getData() {
    const data = super.getData();
    data.sourceAnchorId = this.sourceAnchorId;
    data.targetAnchorId = this.targetAnchorId;
    return data;
  }
}

export class TriangleFilledEdge extends PolylineEdge {
  getEndArrow() {
    return h('path', {
      stroke: '#ff4d4f',
      strokeWidth: 1,
      fill: '#ff4d4f',
      d: 'M 0 0 -10 -5 -10 5 z',
    });
  }
}

// 空心三角形边
export class TriangleHollowEdgeModel extends PolylineEdgeModel {
  getEdgeStyle() {
    const style = super.getEdgeStyle();
    style.stroke = '#1890ff';
    style.strokeWidth = 2;
    return style;
  }

  // 重写getData方法以保存锚点信息
  getData() {
    const data = super.getData();
    data.sourceAnchorId = this.sourceAnchorId;
    data.targetAnchorId = this.targetAnchorId;
    return data;
  }
}

export class TriangleHollowEdge extends PolylineEdge {
  getEndArrow() {
    return h('path', {
      stroke: '#1890ff',
      strokeWidth: 2,
      fill: '#ffffff',
      d: 'M 0 0 -10 -5 -10 5 z',
    });
  }
}

// 实心圆形边
export class CircleFilledEdgeModel extends PolylineEdgeModel {
  getEdgeStyle() {
    const style = super.getEdgeStyle();
    style.stroke = '#52c41a';
    style.strokeWidth = 2;
    return style;
  }

  // 重写getData方法以保存锚点信息
  getData() {
    const data = super.getData();
    data.sourceAnchorId = this.sourceAnchorId;
    data.targetAnchorId = this.targetAnchorId;
    return data;
  }
}

export class CircleFilledEdge extends PolylineEdge {
  getEndArrow() {
    return h('circle', {
      cx: -6,
      cy: 0,
      r: 4,
      fill: '#52c41a',
      stroke: '#52c41a',
      strokeWidth: 1,
    });
  }
}

// 空心圆形边
export class CircleHollowEdgeModel extends PolylineEdgeModel {
  getEdgeStyle() {
    const style = super.getEdgeStyle();
    style.stroke = '#722ed1';
    style.strokeWidth = 2;
    return style;
  }

  // 重写getData方法以保存锚点信息
  getData() {
    const data = super.getData();
    data.sourceAnchorId = this.sourceAnchorId;
    data.targetAnchorId = this.targetAnchorId;
    return data;
  }
}

export class CircleHollowEdge extends PolylineEdge {
  getEndArrow() {
    return h('circle', {
      cx: -6,
      cy: 0,
      r: 4,
      fill: '#ffffff',
      stroke: '#722ed1',
      strokeWidth: 2,
    });
  }
}

// 实心菱形边
export class DiamondFilledEdgeModel extends PolylineEdgeModel {
  getEdgeStyle() {
    const style = super.getEdgeStyle();
    style.stroke = '#fa8c16';
    style.strokeWidth = 2;
    return style;
  }

  // 重写getData方法以保存锚点信息
  getData() {
    const data = super.getData();
    data.sourceAnchorId = this.sourceAnchorId;
    data.targetAnchorId = this.targetAnchorId;
    return data;
  }
}

export class DiamondFilledEdge extends PolylineEdge {
  getEndArrow() {
    const size = 5;
    return h('path', {
      stroke: '#fa8c16',
      strokeWidth: 1,
      fill: '#fa8c16',
      d: `M 0 0 L -${size} -${size / 2} L -${size * 2} 0 L -${size} ${size / 2} Z`,
    });
  }
}

// 空心菱形边
export class DiamondHollowEdgeModel extends PolylineEdgeModel {
  getEdgeStyle() {
    const style = super.getEdgeStyle();
    style.stroke = '#eb2f96';
    style.strokeWidth = 2;
    return style;
  }

  // 重写getData方法以保存锚点信息
  getData() {
    const data = super.getData();
    data.sourceAnchorId = this.sourceAnchorId;
    data.targetAnchorId = this.targetAnchorId;
    return data;
  }
}

export class DiamondHollowEdge extends PolylineEdge {
  getEndArrow() {
    const size = 5;
    return h('path', {
      stroke: '#eb2f96',
      strokeWidth: 2,
      fill: '#ffffff',
      d: `M 0 0 L -${size} -${size / 2} L -${size * 2} 0 L -${size} ${size / 2} Z`,
    });
  }
}

// 中间箭头边
export class MiddleArrowEdgeModel extends PolylineEdgeModel {
  getEdgeStyle() {
    const style = super.getEdgeStyle();
    style.stroke = '#586D8C';
    style.strokeWidth = 2;
    return style;
  }

  // 重写getData方法以保存锚点信息
  getData() {
    const data = super.getData();
    data.sourceAnchorId = this.sourceAnchorId;
    data.targetAnchorId = this.targetAnchorId;
    return data;
  }
}

export class MiddleArrowEdge extends PolylineEdge {
  // 不显示结束箭头
  getEndArrow() {
    return null;
  }

  // 不显示开始箭头
  getStartArrow() {
    return null;
  }

  // 在中间添加箭头标记
  getShape() {
    const { model } = this.props;
    const { startPoint, endPoint, pointsList } = model;
    const points = pointsList.map(point => `${point.x},${point.y}`).join(' ');

    // 计算中点位置和角度
    let midX: number,
      midY: number,
      angle: number = 0;

    if (pointsList.length >= 2) {
      // 计算路径中点
      const totalLength = this.calculatePathLength(pointsList);
      const halfLength = totalLength / 2;
      const { point, segmentAngle } = this.getPointAtLength(
        pointsList,
        halfLength
      );
      midX = point.x;
      midY = point.y;
      angle = segmentAngle;
    } else {
      // 如果只有两个点，取中点
      midX = (startPoint.x + endPoint.x) / 2;
      midY = (startPoint.y + endPoint.y) / 2;
      angle =
        (Math.atan2(endPoint.y - startPoint.y, endPoint.x - startPoint.x) *
          180) /
        Math.PI;
    }

    const style = model.getEdgeStyle();

    return h('g', {}, [
      h('polyline', {
        points,
        stroke: style.stroke,
        strokeWidth: style.strokeWidth,
        fill: 'none',
      }),
      // 中间的三角形箭头（调整为与其他三角形相同大小）
      h('polygon', {
        points: '0,-8 15,0 0,8',
        fill: '#586D8C',
        stroke: '#586D8C',
        transform: `translate(${midX},${midY}) rotate(${angle})`,
      }),
    ]);
  }

  // 计算路径总长度
  private calculatePathLength(points: Array<{ x: number; y: number }>): number {
    let length = 0;
    for (let i = 1; i < points.length; i++) {
      const dx = points[i].x - points[i - 1].x;
      const dy = points[i].y - points[i - 1].y;
      length += Math.sqrt(dx * dx + dy * dy);
    }
    return length;
  }

  // 根据长度获取路径上的点和该点的角度
  private getPointAtLength(
    points: Array<{ x: number; y: number }>,
    targetLength: number
  ): { point: { x: number; y: number }; segmentAngle: number } {
    let currentLength = 0;

    for (let i = 1; i < points.length; i++) {
      const dx = points[i].x - points[i - 1].x;
      const dy = points[i].y - points[i - 1].y;
      const segmentLength = Math.sqrt(dx * dx + dy * dy);

      if (currentLength + segmentLength >= targetLength) {
        const ratio = (targetLength - currentLength) / segmentLength;
        const x = points[i - 1].x + dx * ratio;
        const y = points[i - 1].y + dy * ratio;
        const angle = (Math.atan2(dy, dx) * 180) / Math.PI;
        return {
          point: { x, y },
          segmentAngle: angle,
        };
      }

      currentLength += segmentLength;
    }

    // 如果没找到，返回最后一个点
    const lastPoint = points[points.length - 1];
    const secondLastPoint = points[points.length - 2];
    const angle =
      (Math.atan2(
        lastPoint.y - secondLastPoint.y,
        lastPoint.x - secondLastPoint.x
      ) *
        180) /
      Math.PI;

    return {
      point: lastPoint,
      segmentAngle: angle,
    };
  }
}

// 中间箭头边 - 类型2（空心三角形+实心三角形组合）
export class MiddleArrowDoubleTriangleEdgeModel extends PolylineEdgeModel {
  getEdgeStyle() {
    const style = super.getEdgeStyle();
    style.stroke = '#586D8C';
    style.strokeWidth = 2;
    return style;
  }

  getData() {
    const data = super.getData();
    data.sourceAnchorId = this.sourceAnchorId;
    data.targetAnchorId = this.targetAnchorId;
    return data;
  }
}

export class MiddleArrowDoubleTriangleEdge extends PolylineEdge {
  getEndArrow() {
    return null;
  }

  getStartArrow() {
    return null;
  }

  getShape() {
    const { model } = this.props;
    const { startPoint, endPoint, pointsList } = model;
    const points = pointsList.map(point => `${point.x},${point.y}`).join(' ');

    let midX: number,
      midY: number,
      angle: number = 0;

    if (pointsList.length >= 2) {
      const totalLength = this.calculatePathLength(pointsList);
      const halfLength = totalLength / 2;
      const { point, segmentAngle } = this.getPointAtLength(
        pointsList,
        halfLength
      );
      midX = point.x;
      midY = point.y;
      angle = segmentAngle;
    } else {
      midX = (startPoint.x + endPoint.x) / 2;
      midY = (startPoint.y + endPoint.y) / 2;
      angle =
        (Math.atan2(endPoint.y - startPoint.y, endPoint.x - startPoint.x) *
          180) /
        Math.PI;
    }

    const style = model.getEdgeStyle();

    return h('g', {}, [
      h('polyline', {
        points,
        stroke: style.stroke,
        strokeWidth: style.strokeWidth,
        fill: 'none',
      }),
      // 外层空心三角形
      h('polygon', {
        points: '0,-8 15,0 0,8',
        fill: 'white',
        stroke: '#586D8C',
        strokeWidth: 3,
        transform: `translate(${midX},${midY}) rotate(${angle})`,
      }),
      // 内层实心三角形（调整位置使其在外层三角形中居中）
      h('polygon', {
        points: '4,-2 8,0 4,2',
        fill: '#586D8C',
        stroke: '#586D8C',
        transform: `translate(${midX},${midY}) rotate(${angle})`,
      }),
    ]);
  }

  private calculatePathLength(points: Array<{ x: number; y: number }>): number {
    let length = 0;
    for (let i = 1; i < points.length; i++) {
      const dx = points[i].x - points[i - 1].x;
      const dy = points[i].y - points[i - 1].y;
      length += Math.sqrt(dx * dx + dy * dy);
    }
    return length;
  }

  private getPointAtLength(
    points: Array<{ x: number; y: number }>,
    targetLength: number
  ): { point: { x: number; y: number }; segmentAngle: number } {
    let currentLength = 0;

    for (let i = 1; i < points.length; i++) {
      const dx = points[i].x - points[i - 1].x;
      const dy = points[i].y - points[i - 1].y;
      const segmentLength = Math.sqrt(dx * dx + dy * dy);

      if (currentLength + segmentLength >= targetLength) {
        const ratio = (targetLength - currentLength) / segmentLength;
        const x = points[i - 1].x + dx * ratio;
        const y = points[i - 1].y + dy * ratio;
        const angle = (Math.atan2(dy, dx) * 180) / Math.PI;
        return {
          point: { x, y },
          segmentAngle: angle,
        };
      }

      currentLength += segmentLength;
    }

    const lastPoint = points[points.length - 1];
    const secondLastPoint = points[points.length - 2];
    const angle =
      (Math.atan2(
        lastPoint.y - secondLastPoint.y,
        lastPoint.x - secondLastPoint.x
      ) *
        180) /
      Math.PI;

    return {
      point: lastPoint,
      segmentAngle: angle,
    };
  }
}

// 中间箭头边 - 类型3（空心三角形）
export class MiddleArrowHollowTriangleEdgeModel extends PolylineEdgeModel {
  getEdgeStyle() {
    const style = super.getEdgeStyle();
    style.stroke = '#586D8C';
    style.strokeWidth = 2;
    return style;
  }

  getData() {
    const data = super.getData();
    data.sourceAnchorId = this.sourceAnchorId;
    data.targetAnchorId = this.targetAnchorId;
    return data;
  }
}

export class MiddleArrowHollowTriangleEdge extends PolylineEdge {
  getEndArrow() {
    return null;
  }

  getStartArrow() {
    return null;
  }

  getShape() {
    const { model } = this.props;
    const { startPoint, endPoint, pointsList } = model;
    const points = pointsList.map(point => `${point.x},${point.y}`).join(' ');

    let midX: number,
      midY: number,
      angle: number = 0;

    if (pointsList.length >= 2) {
      const totalLength = this.calculatePathLength(pointsList);
      const halfLength = totalLength / 2;
      const { point, segmentAngle } = this.getPointAtLength(
        pointsList,
        halfLength
      );
      midX = point.x;
      midY = point.y;
      angle = segmentAngle;
    } else {
      midX = (startPoint.x + endPoint.x) / 2;
      midY = (startPoint.y + endPoint.y) / 2;
      angle =
        (Math.atan2(endPoint.y - startPoint.y, endPoint.x - startPoint.x) *
          180) /
        Math.PI;
    }

    const style = model.getEdgeStyle();

    return h('g', {}, [
      h('polyline', {
        points,
        stroke: style.stroke,
        strokeWidth: style.strokeWidth,
        fill: 'none',
      }),
      // 空心三角形
      h('polygon', {
        points: '0,-8 15,0 0,8',
        fill: 'white',
        stroke: '#586D8C',
        strokeWidth: 3,
        transform: `translate(${midX},${midY}) rotate(${angle})`,
      }),
    ]);
  }

  private calculatePathLength(points: Array<{ x: number; y: number }>): number {
    let length = 0;
    for (let i = 1; i < points.length; i++) {
      const dx = points[i].x - points[i - 1].x;
      const dy = points[i].y - points[i - 1].y;
      length += Math.sqrt(dx * dx + dy * dy);
    }
    return length;
  }

  private getPointAtLength(
    points: Array<{ x: number; y: number }>,
    targetLength: number
  ): { point: { x: number; y: number }; segmentAngle: number } {
    let currentLength = 0;

    for (let i = 1; i < points.length; i++) {
      const dx = points[i].x - points[i - 1].x;
      const dy = points[i].y - points[i - 1].y;
      const segmentLength = Math.sqrt(dx * dx + dy * dy);

      if (currentLength + segmentLength >= targetLength) {
        const ratio = (targetLength - currentLength) / segmentLength;
        const x = points[i - 1].x + dx * ratio;
        const y = points[i - 1].y + dy * ratio;
        const angle = (Math.atan2(dy, dx) * 180) / Math.PI;
        return {
          point: { x, y },
          segmentAngle: angle,
        };
      }

      currentLength += segmentLength;
    }

    const lastPoint = points[points.length - 1];
    const secondLastPoint = points[points.length - 2];
    const angle =
      (Math.atan2(
        lastPoint.y - secondLastPoint.y,
        lastPoint.x - secondLastPoint.x
      ) *
        180) /
      Math.PI;

    return {
      point: lastPoint,
      segmentAngle: angle,
    };
  }
}

// 中间箭头边 - 类型4（空心三角形+圆形组合）
export class MiddleArrowTriangleCircleEdgeModel extends PolylineEdgeModel {
  getEdgeStyle() {
    const style = super.getEdgeStyle();
    style.stroke = '#586D8C';
    style.strokeWidth = 2;
    return style;
  }

  getData() {
    const data = super.getData();
    data.sourceAnchorId = this.sourceAnchorId;
    data.targetAnchorId = this.targetAnchorId;
    return data;
  }
}

export class MiddleArrowTriangleCircleEdge extends PolylineEdge {
  getEndArrow() {
    return null;
  }

  getStartArrow() {
    return null;
  }

  getShape() {
    const { model } = this.props;
    const { startPoint, endPoint, pointsList } = model;
    const points = pointsList.map(point => `${point.x},${point.y}`).join(' ');

    let midX: number,
      midY: number,
      angle: number = 0;

    if (pointsList.length >= 2) {
      const totalLength = this.calculatePathLength(pointsList);
      const halfLength = totalLength / 2;
      const { point, segmentAngle } = this.getPointAtLength(
        pointsList,
        halfLength
      );
      midX = point.x;
      midY = point.y;
      angle = segmentAngle;
    } else {
      midX = (startPoint.x + endPoint.x) / 2;
      midY = (startPoint.y + endPoint.y) / 2;
      angle =
        (Math.atan2(endPoint.y - startPoint.y, endPoint.x - startPoint.x) *
          180) /
        Math.PI;
    }

    const style = model.getEdgeStyle();

    return h('g', {}, [
      h('polyline', {
        points,
        stroke: style.stroke,
        strokeWidth: style.strokeWidth,
        fill: 'none',
      }),
      // 空心三角形
      h('polygon', {
        points: '0,-8 15,0 0,8',
        fill: 'white',
        stroke: '#586D8C',
        strokeWidth: 3,
        transform: `translate(${midX},${midY}) rotate(${angle})`,
      }),
      // 圆形（调整位置使其在外层三角形中居中）
      h('circle', {
        cx: 4.58,
        cy: 0,
        r: 2.5,
        fill: '#586D8C',
        stroke: '#586D8C',
        transform: `translate(${midX},${midY}) rotate(${angle})`,
      }),
    ]);
  }

  private calculatePathLength(points: Array<{ x: number; y: number }>): number {
    let length = 0;
    for (let i = 1; i < points.length; i++) {
      const dx = points[i].x - points[i - 1].x;
      const dy = points[i].y - points[i - 1].y;
      length += Math.sqrt(dx * dx + dy * dy);
    }
    return length;
  }

  private getPointAtLength(
    points: Array<{ x: number; y: number }>,
    targetLength: number
  ): { point: { x: number; y: number }; segmentAngle: number } {
    let currentLength = 0;

    for (let i = 1; i < points.length; i++) {
      const dx = points[i].x - points[i - 1].x;
      const dy = points[i].y - points[i - 1].y;
      const segmentLength = Math.sqrt(dx * dx + dy * dy);

      if (currentLength + segmentLength >= targetLength) {
        const ratio = (targetLength - currentLength) / segmentLength;
        const x = points[i - 1].x + dx * ratio;
        const y = points[i - 1].y + dy * ratio;
        const angle = (Math.atan2(dy, dx) * 180) / Math.PI;
        return {
          point: { x, y },
          segmentAngle: angle,
        };
      }

      currentLength += segmentLength;
    }

    const lastPoint = points[points.length - 1];
    const secondLastPoint = points[points.length - 2];
    const angle =
      (Math.atan2(
        lastPoint.y - secondLastPoint.y,
        lastPoint.x - secondLastPoint.x
      ) *
        180) /
      Math.PI;

    return {
      point: lastPoint,
      segmentAngle: angle,
    };
  }
}

// 双向箭头边
export class BidirectionalArrowEdgeModel extends PolylineEdgeModel {
  getEdgeStyle() {
    const style = super.getEdgeStyle();
    style.stroke = '#333333';
    style.strokeWidth = 2;
    return style;
  }

  // 重写getData方法以保存锚点信息
  getData() {
    const data = super.getData();
    data.sourceAnchorId = this.sourceAnchorId;
    data.targetAnchorId = this.targetAnchorId;
    return data;
  }
}

export class BidirectionalArrowEdge extends PolylineEdge {
  // 起始端箭头
  getStartArrow() {
    return h('path', {
      stroke: '#333333',
      strokeWidth: 1,
      fill: '#333333',
      d: 'M 0 0 10 -4 10 4 z',
    });
  }

  // 结束端箭头
  getEndArrow() {
    return h('path', {
      stroke: '#333333',
      strokeWidth: 1,
      fill: '#333333',
      d: 'M 0 0 -10 -4 -10 4 z',
    });
  }
}
